module.exports = __webpack_public_path__ + "img/moi.557425e3.jpg";